const flickity = (() => {

    var flickitySlider = document.getElementsByClassName('mainCarousel');
    if (flickitySlider.length > 0) {

        // external js: flickity.pkgd.js
        var utils = window.fizzyUIUtils;

        var mainCarousel = document.querySelector('.mainCarousel');
        var flkty = new Flickity( mainCarousel, {
            sync: '.textBox',
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            cellSelector: '.carousel-cell'
        });
        
        var textBox = document.querySelector('.textBox');
        var flkty2 = new Flickity( textBox, {
            sync: '.mainCarousel',
            fade: true,
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            cellSelector: '.carousel-cell'
        });

    
    
        // previous
        var previousButton = document.querySelector('.button--previous');
        previousButton.addEventListener( 'click', function() {
            flkty.previous();
        });
        // next
        var nextButton = document.querySelector('.button--next');
        nextButton.addEventListener( 'click', function() {
            flkty.next();
        });


        var carouselStatus = document.querySelector('.carousel-status');

        function updateStatus() {
            var slideNumber = flkty.selectedIndex + 1;
            carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
        }
        updateStatus();

        flkty.on( 'select', updateStatus );
    }

})();
  
export default flickity;